import React from 'react';
import { ExtendedContentContainer } from 'components/ExtendedContent/ExtendedContentContainer';
import StaticHtmlComponent from 'components/StaticHtmlComponent';

export const StaticHtmlModalComponent = ({ extendedResource, extendedContentType, extendedResourceStyle }) => {

    return (
        <ExtendedContentContainer extendedContentType={extendedContentType} extendedResourceStyle={extendedResourceStyle}>
            <StaticHtmlComponent html={extendedResource} extendedResourceStyle={extendedResourceStyle}/>
        </ExtendedContentContainer>
    )
};
